<div class="container-sm">
  <div class="card-list">
    <mb-contact-person-card
      *ngFor="let contact of data.contacts"
      class="column-card"
      [fullname]="contact.fullname"
      [position]="contact.position"
      [email]="contact.email"
      [phone]="contact.phone"
      [media]="contact.image"
      [initials]="contact.initials"
      [hideMedia]="false"
    ></mb-contact-person-card>
  </div>
</div>
